import moment from "moment";
import { Tooltip } from "antd";
import { MoreMenu } from "datastake-daf/dist/components";
import { camelCaseToTitle } from "../../../helpers/StringHelper";
import { getInputContentNew } from "../../../components/DynamicViewNew/helper";
import { getSectionLabel } from "../../Edit/helper";

export const renderData = (v, form = {}, key) => {
  let label;
  const input = form[key];

  if (v && typeof v === 'object' && !Array.isArray(v)) {
    label = Object.keys(v).map((k) => `${k}: ${v[k]}`).join(', ');
  } else if (Array.isArray(v)) {
    label = 'Array';
  } else {
    label = v || '--';
  }

  label = getInputContentNew({ ...input, value: v }, form);

  return <Tooltip title={label}>{label}</Tooltip>
}

export const renderFormLabel = (form, dataId, item) => {
  if(form?.[dataId] && form?.[dataId]?.label) {
    const label = form?.[dataId]?.label;
   
    return getSectionLabel(label, item);
  }
  return camelCaseToTitle(dataId);
}

export const getStandardColumns = ({
  t,
  form = {},
  setSettingsVisible = () => { },
}) => [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }
        return item.datastakeId || item.id
      },
    },
    {
      title: t('Data Point'),
      dataIndex: 'dataId',
      key: 'dataId',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return renderFormLabel(form, v, item);
      },
    },
    {
      title: t('Data'),
      dataIndex: 'data',
      key: 'data',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return renderData(v, form, item.dataId);
      },
    },
    {
      title: t('Version'),
      dataIndex: 'version',
      key: 'version',
      ellipsis: true,
    },
    {
      title: t('Date'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return v ? moment(v).format('DD MMM YYYY') : '--';
      },
      ellipsis: true,
    },
    {
      width: 60,
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (i, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const items = [
          {
            key: "edit",
            onClick: () => {
              setSettingsVisible(true);
            },
            label: t('Datapoint Settings'),
          },
        ]

        return <MoreMenu items={items} />;
      },
    },
  ];

export const getLinkedColumns = ({ t, forms = {} }) => [
  {
    title: t('ID'),
    dataIndex: 'datastakeId',
    key: 'datastakeId',
    ellipsis: true,
  },
  {
    title: t('Subject Type'),
    dataIndex: 'type',
    key: 'type',
    ellipsis: true,
    render: (val) => {
      switch (val) {
        case 'document':
          return t('Document');
        case 'event':
          return t('Event');
        case 'stakeholder':
          return t('Stakeholder');
        case 'location':
          return t('Location');
        default:
          return '--';
      }
    },
  },
  {
    title: t('Category'),
    dataIndex: 'category',
    key: 'category',
    ellipsis: true,
    render: (val, all) => {
      switch (all.type) {
        case 'document':
        case 'event':
          return camelCaseToTitle(val);
        case 'stakeholder':
          const sVal = (forms?.entities?.category?.options || []).find((v) => v.value === val);
          return sVal?.label || val;
        case 'location':
          const lVal = (forms?.locations?.category?.options || []).find((v) => v.value === val);
          return lVal?.label || val;
        default:
          return '--';
      }
    },
  },
  {
    title: t('Name'),
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
  {
    title: t('Nature'),
    dataIndex: 'nature',
    key: 'nature',
    ellipsis: true,
    render: (v) => v || '--',
  },
  {
    title: t('Date'),
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (v) => v ? moment(v).format('DD MMM YYYY') : '--',
    ellipsis: true,
  },
];
